import { createContext, useContext, useReducer } from "react";
import PropTypes from "prop-types";

const JoinStatusContext = createContext();
JoinStatusContext.displayName = "joinStatus";

export const useJoinStatus = () => useContext(JoinStatusContext);

export const JoinStatusProvider = ({ children, initialState, reducer }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <JoinStatusContext.Provider value={[state, dispatch]}>
      {children}
    </JoinStatusContext.Provider>
  );
};

JoinStatusProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    errorCode: PropTypes.string.isRequired,
  }),
  reducer: PropTypes.func.isRequired,
};
